import { replaceQueryParam } from './replace-query-param.js';

/**
 * @description Replace multiple query parameters without `URLSearchParams`
 * This is a way to replace query parameters in a string
 * without unwanted encoding other properties
 */ const replaceQueryParams = (paramSets, search)=>{
    return paramSets.reduce((prev, { name , newValue  })=>{
        return replaceQueryParam({
            name,
            newValue
        }, prev);
    }, search);
};

export { replaceQueryParams };
//# sourceMappingURL=replace-query-params.js.map
